<div class="popup-backdrop" (click)="closePopup()">
  <div class="popup-container" (click)="$event.stopPropagation()">
    <button class="close-button" (click)="closePopup()">
      <svg class="close-svg" viewBox="0 0 47 47" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M42 41.9102L5.08903 4.99918" stroke="#29BF65" stroke-width="9.66667" stroke-linecap="round"/>
<path d="M5 41.9102L41.911 4.99918" stroke="#29BF65" stroke-width="9.66667" stroke-linecap="round"/>
</svg>

    </button>
    <div class="popup-content">
      <img src="assets/images/ingredients.png" alt="Restore Warning" class="restore-image" />
      <div class="restore-title" >{{ title }}</div>
      <div class="restore-subtitle">{{ subtitle }}</div>
      <button class="ok-btn" (click)="closePopup()">{{ okButtonText }}</button>
      <div [ngStyle]="{'height': (safeAreaBottom) + 'px'}" ></div>
    </div>
  </div>
</div>
